import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6xvu4qtx: FaireBrandEntity = {
  token: "b_6xvu4qtx",
  type: "brand",
  name: "Verve Culture",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/25c932e6587a0772f5d41a80f5782c1f58794369f35be9a9076a4866924fab87/1541116754.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/324b25c0e1694e52e460b821c0ec00ffaf2274dbf7c8c7fde3c2bcf7735921af.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/25c932e6587a0772f5d41a80f5782c1f58794369f35be9a9076a4866924fab87/1541116754.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/324b25c0e1694e52e460b821c0ec00ffaf2274dbf7c8c7fde3c2bcf7735921af.jpeg",
  location: "Steamboat Springs, CO, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 960,
  isTopShop: true,
  isInsider: true,
  description:
    "One of the best things about travel is that we see new places, meet new people, experience new foods, customs and activities – it is the inhaling of the essences of the PLACE and it has the power to move us with secrets and history. Verve Culture is dedicated to bringing some of these experiences to you even if you can’t travel or have traveled and want to connect again to those memories or aspirations. We present items that are truly iconic but with today’s vibe that honor traditions and heritage and the people that make them. ",
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:46:13.532Z",
    importedBy: "entity-db-cli",
  },
};
